export const addFormData = formData => ({
  type: "formData",
  payload: {formData}
})